import { render, staticRenderFns } from "./DownloadPluginsUserTable.vue?vue&type=template&id=31d2225b"
import script from "./DownloadPluginsUserTable.vue?vue&type=script&lang=js"
export * from "./DownloadPluginsUserTable.vue?vue&type=script&lang=js"
import style0 from "./DownloadPluginsUserTable.vue?vue&type=style&index=0&id=31d2225b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports